import { render, staticRenderFns } from "./IDE.vue?vue&type=template&id=10300c64&"
import script from "./IDE.vue?vue&type=script&lang=js&"
export * from "./IDE.vue?vue&type=script&lang=js&"
import style0 from "./IDE.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports